import {
    HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DiagnosticsService } from './diagnostics.service';

// The report itself is not useful in a problem report. Uploads are kept: the endpoint is shared with other screens.
const IGNORED_URL_PARTS = ['/problem-reports'];

@Injectable()
export class DiagnosticsInterceptor implements HttpInterceptor {
    constructor(private diagnostics: DiagnosticsService) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            catchError((error) => {
                if (error instanceof HttpErrorResponse && !IGNORED_URL_PARTS.some((part) => req.url.includes(part))) {
                    this.diagnostics.recordHttpError(req.method, req.url, error);
                }
                return throwError(error);
            }),
        );
    }
}

export const DIAGNOSTICS_INTERCEPTOR_PROVIDER = {
    provide: HTTP_INTERCEPTORS,
    useClass: DiagnosticsInterceptor,
    multi: true,
};
